import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    title: 'El Truco del Orden de la Comida',
    desc: 'Reduce 75% el pico de insulina sin cambiar tu plato'
  }, {
    title: 'La Dieta Metabólica Latina',
    desc: 'Los 10 superalimentos latinos que hackean tu insulina'
  }, {
    title: 'La Regla 30/30 del Desayuno',
    desc: 'Estabiliza tu glucosa desde la primera hora del día'
  }, {
    title: 'Hackeando el Cortisol',
    desc: '3 técnicas de 2 minutos para frenar la acumulación de grasa'
  }, {
    title: 'El Plan de 30 Días',
    desc: 'Tu mapa completo semana a semana con guía de restaurantes y eventos'
  }];
  return <section className="w-full bg-gradient-to-b from-[#006060] to-[#003D3D] py-20 px-4" data-id="element-269">
      <div className="max-w-[960px] mx-auto text-white" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center text-center mb-12" data-id="element-271">
          <span className="bg-orange text-white text-[12px] uppercase font-bold px-4 py-1.5 rounded-full mb-6" data-id="element-272">
            PRESENTANDO EL SISTEMA COMPLETO
          </span>
          <h2 className="text-[32px] md:text-[44px] font-bold mb-4" data-id="element-273">
            El Protocolo Reinicio 40+
          </h2>
          <p className="text-[18px] md:text-[20px] text-white/85 max-w-2xl" data-id="element-274">
            El Sistema de 3 Ejes Para Recuperar tu Metabolismo, tu Cintura y tu
            Energía
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-275">
          {benefits.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-276">
              <div className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-teal flex items-center justify-center border border-white/20 shadow-lg" data-id="element-277">
                <Check className="w-5 h-5 text-white" data-id="element-278" />
              </div>
              <div data-id="element-279">
                <h4 className="text-[17px] font-bold text-white mb-1" data-id="element-280">
                  {item.title}
                </h4>
                <p className="text-[15px] text-white/75 leading-relaxed" data-id="element-281">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}